<template>
  <LegalSiteArticle :page="termsPage" nav-page="terms" />
</template>

<script>
import LegalSiteArticle from '@/components/LegalSiteArticle.vue'
import { termsPage } from '@/data/legalPages'

export default {
  components: { LegalSiteArticle },
  data() {
    return { termsPage }
  },
}
</script>
